module.exports = __webpack_public_path__ + "img/autosense-compatibility-check-round.26ea8079.png";